import get from 'lodash/get';

export const freeFormMap = {
  'marketing-email': 'EmailAlert',
  'marketing-faqs': 'FAQ',
  'marketing-hero-not-entitled': 'Hero',
  'marketing-hero': 'Hero',
  'marketing-landing-exclusive': 'ExclusiveContent',
  'marketing-perks': 'Perks',
  'marketing-personalities': 'ShowsGrid',
  'marketing-shows': 'ShowsGrid',
  'marketing-upgrade': 'ButtonCTA',
};

export const getUrlParam = (param, isFlag = false) => {
  const searchQuery = window && window.location && window.location.search;
  if (!param || !searchQuery) return false;
  const query = new URLSearchParams(searchQuery);

  if (isFlag) return query.get(param) && query.get(param) !== 'false';

  return query.get(param);
};

export const mapHero = (data) => {
  const modifiedResponse = {
    source: [],
  };
  if (data && data.items && data.items.member) {
    const heroPanels = []; // store hero panels
    const textPanels = {}; // store text panels
    data.items.member.forEach((item) => {
      if (item.promoType === 'hero') {
        const { headline, alternativeHeadline, description, images, autoPlayStill = {}, ctaText, name, url } = item;
        if (images && images.heroPromoImage) {
          images.url = images.heroPromoImage;
        }
        const isConfirmationHero = name.toLowerCase().includes('confirmation');
        const defaultImage = (autoPlayStill && autoPlayStill.default) || item.image || images || null;
        const { portraitTablet = null, portraitHandset = null } = autoPlayStill;
        heroPanels.push({
          headline,
          alternativeHeadline,
          description,
          image: {
            defaultImage,
            portraitTablet,
            portraitHandset,
          },
          ctaText,
          url,
          isConfirmationHero,
        });
      }
      if (item.promoType === 'text') {
        const { ctaText, headline, alternativeHeadline, description, subDescription } = item;
        textPanels.cta = {
          ctaText,
          headline,
          alternativeHeadline,
          description,
          subDescription,
        };
      }
    });

    const heroData = heroPanels.map((data) => {
      return {
        ...data,
        ...textPanels,
      };
    });
    modifiedResponse.source = heroData;
  }
  return modifiedResponse;
};

export const mapPerks = (data) => {
  const modifiedResponse = {
    source: [],
  };
  if (data && data.items && data.items.member) {
    const perks = data.items.member.map((item) => {
      const { headline, description, subDescription } = item;
      return { headline, description, subDescription };
    });
    modifiedResponse.source = perks;
  }
  return modifiedResponse;
};

export const mapShowsGrid = (data) => {
  let modifiedResponse = {};
  if (data && data.items && data.items.member) {
    const {
      headline,
      description,
      items: { member },
    } = data;
    const shows = member
      .filter((item) => item.images && item.images.seriesList && item.images.seriesList.SD)
      .map((show) => show);
    if (shows.length > 0) {
      modifiedResponse = {
        headline,
        description,
        shows,
      };
    }
  }
  return modifiedResponse;
};

export const mapFAQ = (data) => {
  let modifiedResponse = {};
  if (data && data.items && data.items.member) {
    const {
      headline,
      items: { member },
    } = data;
    const faq = member.map((item) => {
      const { text, headline, description, subDescription, url } = item;
      return { text, headline, description, subDescription, url };
    });
    modifiedResponse = {
      headline,
      source: faq,
    };
  }
  return modifiedResponse;
};

export const mapEmailAlert = (data) => {
  const { description, headline, ctaText } = data.items.member[0];
  return { description, headline, ctaText };
};

export const mapButtonCTA = (data) => {
  let modifiedResponse = {};
  const items = get(data, 'items', null);
  if (items && items.member && items.member.length) {
    data.items.member.forEach((item) => {
      const { headline = '', description = '', ctaText = '', url = '', images = '' } = item;
      const image = images && images.heroPromoImage ? images.heroPromoImage : null;
      modifiedResponse = { headline, description, ctaText, url, image };
    });
  }
  return modifiedResponse;
};

export const mapExclusiveContentModule = (data) => {
  let modifiedResponse = {};
  if (data && data.items && data.items.member && data.items.member.length) {
    const {
      headline,
      items: { member },
    } = data;
    modifiedResponse = { headline, member };
  }
  return modifiedResponse;
};

export const mapDppDataToProps = (data, type) => {
  if (!data && !Array.isArray(data)) {
    return null;
  }
  switch (type) {
    case 'Hero':
      return mapHero(data);
    case 'Perks':
      return mapPerks(data);
    case 'ShowsGrid':
      return mapShowsGrid(data);
    case 'FAQ':
      return mapFAQ(data);
    case 'EmailAlert':
      return mapEmailAlert(data);
    case 'ButtonCTA':
      return mapButtonCTA(data);
    case 'ExclusiveContent':
      return mapExclusiveContentModule(data);
    default:
      return data;
  }
};

export const parseDppContent = (member = []) =>
  member.reduce((acc, item) => {
    const { collectionType } = item;
    const freeFormComponent = freeFormMap[collectionType];
    if (freeFormComponent) {
      return [
        ...acc,
        {
          component: freeFormComponent,
          panelProps: mapDppDataToProps(item, freeFormComponent),
        },
      ];
    }
    return acc;
  }, []);

export const withImageOptimizerBySizeAndType = (imageUrl, cropBySize = 1200, outputFormat = 'jpg') => {
  return `${imageUrl}?output-format=${outputFormat}&fit=inside|${cropBySize}:*`;
};

export const withImageOptimizerBySize = (imageUrl, cropBySize = 1200) => {
  return withImageOptimizerBySizeAndType(imageUrl, cropBySize);
};

export const withImageOptimizer = (imageUrl) => withImageOptimizerBySize(imageUrl);
